
import React, { useEffect } from "react";

interface EditorContentProps {
  editorRef: React.RefObject<HTMLDivElement>;
  value: string;
  placeholder: string;
  className?: string;
  handleInput: () => void;
  isFocused: boolean;
  setIsFocused: (focused: boolean) => void;
}

export const EditorContent: React.FC<EditorContentProps> = ({
  editorRef,
  value,
  placeholder,
  className = "",
  handleInput,
  isFocused,
  setIsFocused
}) => {
  // Show placeholder when the editor is empty
  const showPlaceholder = !value && !isFocused && placeholder;
  
  // Update the editor content properly when value changes
  useEffect(() => {
    if (editorRef.current) {
      // Only update innerHTML if not focused to prevent cursor position issues
      if (!isFocused) {
        editorRef.current.innerHTML = value;
      }
    }
  }, [value, isFocused, editorRef]);

  return (
    <div className="relative">
      {showPlaceholder && (
        <div className="absolute top-3 left-3 text-muted-foreground pointer-events-none">
          {placeholder}
        </div>
      )}
      <div
        ref={editorRef}
        contentEditable
        className={`min-h-[150px] p-3 focus:outline-none ${className}`}
        onInput={handleInput}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        suppressContentEditableWarning={true}
      />
    </div>
  );
};
